import { Injectable } from "../reflection/injectable";

// Safari lanza SecurityError al acceder a sessionStorage si el usuario bloquea las cookies
@Injectable({ type: 'singleton' })
export class SessionStorageService {

    public constructor() {        
    }

    public set(key: string, value: any): void {
        try {
            window.sessionStorage.setItem(key, value != null ? JSON.stringify(value): null);
        } 
        catch (error) {
            console.warn(`SessionStorageService: no se ha podido guardar "${key}"`, error);
        }
    }

    public get(key: string): any {
        try {
            const value: string = window.sessionStorage.getItem(key);
            return value ? JSON.parse(value): null;
        } 
        catch (error) {
            console.warn(`SessionStorageService: no se ha podido leer "${key}"`, error);
            return null;
        }
    }

    public remove(key: string): void {
        try {
            window.sessionStorage.removeItem(key);
        } 
        catch (error) {
            console.warn(`SessionStorageService: no se ha podido eliminar "${key}"`, error);
        }
    }
}
